import { Box, Button, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { selectUserInfo } from "features/user/userSlice";
import { useSelector } from "react-redux";
import AlertMessages from "common/Alert/AlertMessages";
import { useNavigate, useParams } from "react-router-dom";
import { InventoryProfileService } from "subModule/src/core/services";
import { GetStockReceiptResponse, PurchaseOrderResponse, SaveInvoice } from "subModule/src/services/inventory/interface";
import Loader from "layout/Loader";
import { useTranslation } from "react-i18next";
import { themes } from "theme/themes";
import { brandingInfo } from "features/server/brandingSlice";
const PrintPurchaseOrderInvoice: React.FC = () => {
    const params = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const branding = useSelector(brandingInfo);
    const themeColors = branding?.attributes?.themeId === 100 ? branding?.attributes?.customTheme : (themes as any)[branding?.attributes?.themeId || 3];
    const loggedInUserCurrency = useSelector(selectUserInfo)?.business?.currency;
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState<boolean>(true);
    const [invoice, setInvoice] = useState<SaveInvoice>();
    // const [IsDataAvailable, setIsDataAvailable] = useState<boolean>(false);
    useEffect(() => {
        if (loading) getStockReceiptByPOId();
    }, []);
    const getStockReceiptByPOId = () => {
        InventoryProfileService.getStockReceiptByPOID(params?.id).then((res: GetStockReceiptResponse) => {
            // if(!res.data) {
            //     setIsDataAvailable(false);
            // } else {
            //     setIsDataAvailable(true);
            // }
            console.log(res);
            getInvoiceById();
        }).catch((err:any) => { console.error("===", err); });
    }
    const getInvoiceById = () => {
        InventoryProfileService.getEntityById(params?.id, 'purchaseinvoice/bypoid').then((res: any) => {
            if (res.success) {
                setInvoice((res.data as any));
                setLoading(false);
            } else {
                setLoading(false);
                enqueueSnackbar(<AlertMessages text={res.message || "Something went wrong"} />, { variant: 'error' });
            }
        }).catch((err: any) => { console.error("===", err); });
    }
    const columns = [
        { id: 'itemId' },
        { id: 'itemCode' },
        { id: 'unitId' },
        { id: 'itemName', label: t('Item'), numeric: false, disablePadding: false, type: 'text' },
        { id: 'supplierSKU', label: t('SKU'), numeric: false, disablePadding: false, type: 'text' },
        { id: 'quantity', label: t('Quantity'), numeric: false, disablePadding: false, type: 'number' },
        { id: 'unitTitle', label: t('unit') },
        { id: 'unitPrice', label: t('Cost'), numeric: false, disablePadding: false, type: 'number' },
        { id: 'discount', label: `${t('Discount')} %`, numeric: false, disablePadding: false, type: 'number' },
        { id: 'total', label: t('Total') },
    ];
    const columnsService = [
        { id: 'serviceId' },
        { id: 'serviceCode' },
        { id: 'serviceName', label: t('service'), numeric: false, disablePadding: false, type: 'text' },
        { id: 'quantity', label: t('Quantity'), numeric: false, disablePadding: false, type: 'number' },
        { id: 'unitPrice', label: t('Cost'), numeric: false, disablePadding: false, type: 'number' },
        { id: 'discount', label: t('Discount'), numeric: false, disablePadding: false, type: 'number' },
        { id: 'total', label: t('Total') },
    ];

    return (
        loading ? <Loader /> : <Box>
            <Box className='max-w-[1100px] bg-white py-[10px] px-[20px] rounded-[8px] block mx-auto hide-on-print mb-4'>
                <Box className='flex justify-between items-center' id='form'>
                    <Typography className="font-Saira text-[12px] font-semibold" style={{ color: themeColors?.primary }}>{t('supplierBill')}</Typography>
                    <Box className='flex gap-2'>
                        <Button className="secondary" variant="contained" style={{ color: themeColors?.primary }} disableElevation onClick={() => navigate(-1)}>{t('back')}</Button>
                        <Button className="primary" variant="contained" style={{ background: themeColors?.primary }} disableElevation onClick={() => window.print()}>{t('Print')}</Button>
                    </Box>
                </Box>
            </Box>
            <Box id="print-root" className='max-w-[1100px] bg-white p-[20px] rounded-[8px] block mx-auto'>
                <Box className='flex justify-between mb-3'>
                    <Typography className="font-Saira text-[12px] text-left">
                        <span className="italic font-medium">{t('Supplier')}: </span>
                        <span className="font-bold">{invoice?.vendorTitle || ''}</span>
                    </Typography>
                    <Box className='flex gap-2'>
                        <span className={`${invoice?.paymentStatus === 777 ? 'unpaid' : invoice?.paymentStatus === 778 ? 'partialpaid' : 'paid'} px-4 py-1 rounded-lg block text-center w-auto font-medium text-[13px] h-[fit-content]`}>
                            {invoice?.paymentStatus === 777
                                ? t("unpaid")
                                    : invoice?.paymentStatus === 778
                                        ? t("partialPaid")
                                            : t("paid")}
                        </span>
                        <Box>
                            <Typography className="font-Saira text-[12px] block py-1 px-2 rounded-[8px]" style={{ background: themeColors?.appBg }}>
                                <span className="font-bold" style={{ color: themeColors?.secondary }}>{t('supplierBill')} # </span>
                                <span className="font-semibold">{invoice?.invoiceNumber || ''}</span>
                            </Typography>
                            <Typography className="font-Saira text-[12px] text-end font-semibold">
                                <span className="italic font-medium">{t('poNumber')}</span>
                                <span>: </span>
                                <span>{invoice?.poNumber || t('none')}</span>
                            </Typography>
                            {invoice?.referenceNumber ? <Typography className="font-Saira text-[12px] text-end font-semibold">
                                <span className="font-bold" style={{ color: themeColors?.secondary }}>{t('referenceNo')}</span>
                                <span>: </span>
                                <span className="font-semibold">{invoice?.referenceNumber || ''}</span>
                            </Typography> : null}
                        </Box>
                    </Box>
                </Box>
                <Box className='flex justify-between items-center py-3 px-2 rounded-[8px] mb-2' style={{ background: themeColors?.appBg }}>
                    <Typography className="font-Saira text-[12px] text-left">
                        <span className="italic font-medium">{t('store')}: </span>
                        <span className="font-bold">{invoice?.storeTitle || ''}</span>
                    </Typography>
                    <Box className="flex gap-3 items-center">
                        <Typography className="font-Saira text-[12px] text-left">
                            <span className="italic font-medium">{t('supplierBill') + ' ' + t('Date')}: </span>
                            <span className="font-bold">{invoice?.invoiceDate?.split('T')[0] || ''}</span>
                        </Typography>
                        {invoice?.dueDate ? <Typography className="font-Saira text-[12px] text-left block py-1 px-3 rounded-[8px]" style={{ background: themeColors?.secondary + '33' }}>
                            <span className="italic font-medium">{t('Due') + ' ' + t('Date')}: </span>
                            <span className="font-bold">{invoice?.dueDate?.split('T')[0] || ''}</span>
                        </Typography> : null}
                    </Box>
                </Box>
                <Typography className="font-Saira text-[12px] font-semibold text-[#333843] text-left mb-2">{t('supplierBill')}</Typography>
                <Box className='w-[100%] mb-2' id="inventorytable">
                    <TableContainer>
                        <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={'small'}>
                            <TableHead>
                                <TableRow sx={{ borderBottom: `1px solid #B8BDCB` }}>
                                    {columns.filter((column) => column.id !== 'itemId' && column.id !== 'itemCode' && column.id !== 'unitId').map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.numeric ? 'right' : 'left'}
                                            padding={column.disablePadding ? 'none' : 'normal'}
                                            sortDirection={false}
                                            className="font-bold text-center"
                                        >{column.label}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ '& tr:nth-child(odd)': { background: `transparent !important` }, '& tr': { borderBottom: `1px solid #B8BDCB` }, '& tr:last-child': { borderBottom: 0 } }}>
                                {(invoice?.purchaseInvoiceItem || []).map((row, index) => {
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return (
                                        <TableRow hover tabIndex={-1} key={row.id} sx={{ height: '36px' }}>
                                            {columns.filter((column) => column.id !== 'itemId' && column.id !== 'itemCode' && column.id !== 'unitId').map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    align={column.numeric ? 'right' : 'left'}
                                                    padding={column.disablePadding ? 'none' : 'normal'}
                                                    component={column.id === 'itemName' ? 'th' : undefined}
                                                    id={column.id === 'itemName' ? labelId : undefined}
                                                    scope={column.id === 'itemName' ? 'row' : undefined}
                                                    className="text-center"
                                                >{column.id === 'receivedDate' || column.id === 'expiryDate'
                                                    ? (row as any)[column.id]?.split('T')[0]
                                                    : column.id === 'unitTitle' ? ((row as any)[column.id] || t('unit(s)'))
                                                    : column.id === 'total' ? 
                                                        <span className='font-bold'>{new Intl.NumberFormat('en-US', loggedInUserCurrency ? {
                                                            style: 'currency',
                                                            currency: loggedInUserCurrency || '',
                                                        } : {}).format(
                                                            ((row?.unitPrice || 0) * (row?.quantity || 0)) - (((row?.unitPrice || 0) * (row?.quantity || 0)) * ((row?.discount || 0)/100))
                                                        )}</span>
                                                    : (row as any)[column.id]
                                                    }</TableCell>
                                            ))}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                {invoice?.purchaseInvoiceService && invoice?.purchaseInvoiceService?.length ? <>
                    <Typography className="font-Saira text-[12px] font-semibold text-[#333843] text-left mb-2">{t('Additional Costs')}</Typography>
                    <Box className='w-[100%]' id="inventorytable">
                        <TableContainer>
                            <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={'small'}>
                                <TableHead>
                                    <TableRow sx={{ borderBottom: `1px solid #B8BDCB` }}>
                                        {columnsService.filter((column) => column.id !== 'serviceId' && column.id !== 'serviceCode').map((column) => (
                                            <TableCell
                                                key={column.id}
                                                align={column.numeric ? 'right' : 'left'}
                                                padding={column.disablePadding ? 'none' : 'normal'}
                                                sortDirection={false}
                                                className="font-bold text-center"
                                            >{column.label}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ '& tr:nth-child(odd)': { background: `transparent !important` }, '& tr': { borderBottom: `1px solid #B8BDCB` }, '& tr:last-child': { borderBottom: 0 } }}>
                                    {(invoice?.purchaseInvoiceService || []).map((row, index) => {
                                        const labelId = `enhanced-table-checkbox-${index}`;
                                        return (
                                            <TableRow hover tabIndex={-1} key={row.id} sx={{ height: '36px' }}>
                                                {columnsService.filter((column) => column.id !== 'serviceId' && column.id !== 'serviceCode').map((column) => (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.numeric ? 'right' : 'left'}
                                                        padding={column.disablePadding ? 'none' : 'normal'}
                                                        component={column.id === 'itemName' ? 'th' : undefined}
                                                        id={column.id === 'itemName' ? labelId : undefined}
                                                        scope={column.id === 'itemName' ? 'row' : undefined}
                                                        className="text-center"
                                                    >{column.id === 'total' ? 
                                                        <span className='font-bold'>{new Intl.NumberFormat('en-US', loggedInUserCurrency ? {
                                                            style: 'currency',
                                                            currency: loggedInUserCurrency || '',
                                                        } : {}).format(
                                                        ((row?.unitPrice || 0) * (row?.quantity || 0)) - (((row?.unitPrice || 0) * (row?.quantity || 0)) * ((row?.discount || 0)/100))
                                                    )}</span> : (row as any)[column.id]}</TableCell>
                                                ))}
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </> : null}
                <Box className='flex justify-end mt-4 mb-3'>
                    <Box className="w-[360px]">
                        <Divider className="bg-[#AEB3C4] mb-2" />
                        <Box className='flex justify-between mb-[5px]'>
                            <Typography className="font-Saira text-[12px] text-left">
                                <span className="font-medium">{t('Requested')}: </span>
                                <span className="italic font-bold ms-1">{invoice?.totalQuantity || ''}</span>
                            </Typography>
                            <Typography className="font-Saira text-[12px] text-left">
                                <span className="font-medium">{t('Received')}: </span>
                                <span className="italic font-bold ms-1">{invoice?.totalReceivedQuantity || ''}</span>
                            </Typography>
                        </Box>
                        <Box className='flex justify-between mb-[5px]'>
                            <Typography className="font-Saira text-[12px] text-left">
                                <span className="font-medium">{t('Subtotal')}: </span>
                                <span className="italic font-bold ms-1">{new Intl.NumberFormat('en-US', {}).format((invoice as PurchaseOrderResponse)?.subtotalAmount || 0) || 0}</span>
                            </Typography>
                            <Typography className="font-Saira text-[12px] text-left">
                                <span className="font-medium">{t('Discount')}: </span>
                                <span className="italic font-bold ms-1">{new Intl.NumberFormat('en-US', {}).format((invoice as PurchaseOrderResponse)?.discount || 0) || 0}</span>
                            </Typography>
                        </Box>
                        <Box className='flex justify-between mb-[5px]'>
                            <Typography className="font-Saira text-[12px] text-left">
                                <span className="font-medium">{t('tax')}: </span>
                                <span className="italic font-bold ms-1">{new Intl.NumberFormat('en-US', {}).format((invoice as PurchaseOrderResponse)?.taxAmount || 0) || 0}</span>
                            </Typography>
                            <Typography className="font-Saira text-[12px] text-left">
                                <span className="font-medium">{t('totalWithTax')}: </span>
                                <span className="uppercase ms-1 font-semibold" style={{ color: themeColors?.primary }}>{loggedInUserCurrency}</span>
                                <span className="italic font-bold ms-1">{new Intl.NumberFormat('en-US', {}).format((invoice as PurchaseOrderResponse)?.totalAmount || 0) || 0}</span>
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                {invoice?.poMemo ? <Box>
                    <Typography className="font-Saira text-[12px] font-semibold text-[#171826] text-left">{t("Comments")}</Typography>
                    <Typography className="font-Saira text-[12px] text-[#171826] text-left">{invoice?.poMemo}</Typography>
                </Box> : null}
            </Box>
        </Box>
    )
}

export default PrintPurchaseOrderInvoice;